import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el producto?',
  a: 'Inmediatamente después del pago recibís un email con el link de descarga de los 6 tomos + 3 bonus en formato PDF. Podés leerlo desde el celular, tablet o PC.'
}, {
  q: '¿Funciona si ya tomé muchos antibióticos?',
  a: 'Sí, de hecho es cuando más lo necesitás. Los antibióticos arrasan la flora protectora y dejan terreno libre para la Cándida. La Fase 2 del protocolo está diseñada específicamente para reconstruir esa flora.'
}, {
  q: '¿Cuánto tarda en verse el resultado?',
  a: 'La mayoría reporta alivio de síntomas agudos en las primeras 72 horas (Fase de Choque). El protocolo completo de 21 días está diseñado para la erradicación duradera.'
}, {
  q: '¿Necesito comprar suplementos caros?',
  a: 'No. El Tomo 3 está basado 100% en supermercados argentinos (Coto, Carrefour, Jumbo) y dietéticas locales. Hay opciones para todos los presupuestos.'
}, {
  q: '¿Esto reemplaza al ginecólogo?',
  a: 'No. Es un protocolo complementario de biología funcional. Ante síntomas graves siempre consultá a un profesional.'
}, {
  q: '¿Puedo hacerlo si estoy menstruando?',
  a: 'Sí. De hecho el período es el momento de mayor vulnerabilidad. El Tomo 2 tiene un apartado específico para adaptar el protocolo durante la menstruación.'
}, {
  q: '¿Y si la cándida me vuelve igual?',
  a: 'El Tomo 6 (Blindaje y Recidivas) y el Bonus 3 (Auditoría de Baño) están diseñados exactamente para eso: identificar y eliminar los factores de riesgo activos en tu entorno.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#F8F5FC] px-6 py-16" data-id="element-57">
      <div className="max-w-2xl mx-auto" data-id="element-58">
        <h2 className="text-[28px] font-bold text-brand-text text-center mb-2 leading-tight" data-id="element-59">
          TUS DUDAS RESUELTAS
        </h2>
        <p className="text-brand-muted text-center text-[16px] mb-10" data-id="element-60">
          Preguntas frecuentes
        </p>

        <div className="flex flex-col border-t border-brand-gray" data-id="element-61">
          {faqs.map((faq, i) => <div key={i} className="border-b border-brand-gray" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between py-5 text-left group" data-id="element-63">
                <span className="text-[16px] font-bold text-brand-text pr-4 group-hover:text-brand-violet transition-colors" data-id="element-64">
                  {faq.q}
                </span>
                <div className="flex-shrink-0 text-brand-violet" data-id="element-65">
                  {openIndex === i ? <MinusIcon size={20} data-id="element-66" /> : <PlusIcon size={20} data-id="element-67" />}
                </div>
              </button>
              <AnimatePresence data-id="element-68">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-69">
                    <p className="text-[15px] text-brand-muted leading-relaxed pb-6" data-id="element-70">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}